import { IAppState } from '../../redux';
import { EPlacingType } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export function selectIsPackagesAvailable(state: IAppState): boolean {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return false;
  }

  const {
    publishOptions: { selectedPlacingType, packageIds },
  } = selectedService;

  return selectedPlacingType === EPlacingType.package && packageIds.length > 0;
}
